// Package Imports
import { notification } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

// Project Imports
import getNotificationColors from 'core/utils/getNotificationColors';

export type NotificationType = 'success' | 'info' | 'warning' | 'error';

const openNotificationWithIcon = (
  type: string | NotificationType,
  message: any,
  description?: any,
  duration: number = 4.5 // Default duration of 4.5 seconds (between 2-5)
) => {
  let desc: React.ReactNode = description;

  if (description) {
    const parts = description
      .split('|')
      .map((part, index) => <p key={index}>{part}</p>);
    desc = parts;
  }

  const { borderColor, backgroundColor } = getNotificationColors(type);
  const notificationBorderStyle = {
    border: `1px solid ${borderColor}`,
    backgroundColor,
  };

  notification[type]({
    message,
    description: desc,
    style: {
      ...notificationBorderStyle,
      borderRadius: '6px',
    },
    duration,
    closeIcon: <CloseOutlined />,
  });
};

export default openNotificationWithIcon;
